import { format } from 'date-fns';
import Maybe from 'graphql/tsutils/Maybe';

export const formatHistoryDate = (
    date?: Maybe<Date>,
    dateFormat = 'do MMM yyyy'
): string | undefined => {
    if (!date) {
        return;
    }
    return format(date, dateFormat);
};
